import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  createEventSuccess: {
    margin: "0 auto",
    textAlign: "center",
    "& .MuiDialogContent-root": {
      padding: 0,
      "& > .MuiBox-root": {
        padding: `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(
          2,
        )} ${theme.spacing(2)}`,
        "&:first-child": {
          borderBottom: "1px solid #d0d0d0",
          paddingBottom: theme.spacing(2),
          gap: "20px",
          display: "grid",
        },
      },
      "& h3": {
        fontSize: "1.5rem",
        fontWeight: "normal",
      },
      "& .MuiTypography-body1": {
        fontSize: "1rem",
        marginTop: theme.spacing(2.5),
        textAlign: "center",
      },
      "& .MuiButton-containedPrimary": {
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(5),
      },
    },
    "& .MuiDialog-scrollPaper": {
      "& .MuiDialog-paper": {
        minWidth: 500,
        maxWidth: 500,
        margin: 0,
      },
    },
  },
  title: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse",
    padding: `${theme.spacing(1)} ${theme.spacing(1)} 0`,
    color: theme.palette.events.blueSecondary,
  },
  ceTutorials: {
    padding: `0 0 ${theme.spacing(2)}`,
    display: "inline-flex",
    flexDirection: "column",
    gap: "10px",
    "& .MuiTypography-body1": {
      marginBottom: theme.spacing(1),
    },
    "& .MuiButton-root": {
      display: "flex",
      margin: 0,
      "& .MuiSvgIcon-root": {
        marginRight: theme.spacing(0.5),
      },
    },
  },
  vt: {
    padding: `${theme.spacing(2.5)} ${theme.spacing(1.5)} ${theme.spacing(
      2.5,
    )} ${theme.spacing(1.875)}`,
    borderBottom: "none",
    "& h4": {
      fontWeight: "normal",
      marginBottom: theme.spacing(2.5),
    },
    "& .video-player-iframe-ctn": {
      height: 240,
    },
    "& .MuiTypography-body1": {
      display: "none",
    },
  },

  eventTutorialText: {
    alignSelf: "center",
  },
  eventTutorialButtonIcon: {
    width: "20px",
    height: "20px",
    marginRight: "20px",
  },
  enterEventButton: {
    textTransform: "none",
  },
}));
